// extracted by mini-css-extract-plugin
export default {"wrapper":"SelectedFilters_wrapper__YFvT7","selectedItem":"SelectedFilters_selectedItem__m9h4f","clearAllBtn":"SelectedFilters_clearAllBtn__pzOyk"};